<script lang="ts" type="module">
    import { beforeUpdate, onDestroy, onMount } from "svelte";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { networkStore } from "../../../../store/networks";
    import { user } from "../../../../store/stores";
    import PlaysCounter from "./Components/PlaysCounter.svelte";
    import SvelteTable from "svelte-table";
    import {
        S3Client,
        AbortMultipartUploadCommand,
        ListBucketsCommand,
        ListObjectsCommand,
        UploadPartCommand,
        PutObjectCommand,
    } from "@aws-sdk/client-s3";
    import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
    import IdColumn from "./Components/DashboardTable/IdColumn.svelte";
    import PreviewColumn from "./Components/DashboardTable/PreviewColumn.svelte";
    import {
        ContentListEntry,
        Permission,
        ReleaseStatus,
    } from "../../../../../admin-service-typescript-client";
    import PlaysTimeline from "./Components/PlaysTimeline.svelte";
    import BaseRowElement from "./Components/DashboardTable/BaseRowElement.svelte";
    import dayjs, { Dayjs } from "dayjs";
    import type {
        IAggregationDataResponse,
        IAggregationResponseItem,
        ICreativeStats,
        IPopObject,
        ITimeRangeStats,
        rangeObject,
    } from "../../../../Types/Stats";
    import { statsStore } from "../../../../store/stats";
    import EventBus from "../../../../GlobalHelper/VertxBridge";
    import Admin from "../../_Admin/Admin.svelte";
    import weekday from "dayjs/plugin/weekday";
    import de from "dayjs/locale/de";
    import { eventbusUrl } from "../../../../settings/settings";
    import TimeSelectDropdown from "./Components/TimeSelectDropdown.svelte";
    import CheckboxElement from "./Components/DashboardTable/CheckboxElement.svelte";
    import { uistate } from "../../../../store/uisstate";
    import ApprovalActionsRowElement from "./Components/DashboardTable/ApprovalActionsRowElement.svelte";
    import ContentPreviewElement from "./Components/DashboardTable/ContentPreviewElement.svelte";
    import Header from "../../Components/Header.svelte";
    import { ListItem } from "carbon-components-svelte";
    import ContentCard from "../../Components/ContentCard.svelte";
    import { useNavigate } from "svelte-navigator";

    dayjs.extend(weekday).locale(de);

    const navigate = useNavigate();
    let newContentModalOpen = false;
    let newContentUrl = "";
    let newContentName = "";
    let graphLabels: string[] = [];
    let iconAsc = "↑";
    let iconDesc = "↓";
    let sortBy = "id";
    let sortOrder = 1;
    let rows = [];
    let loading = true;
    let searchObject: { [key: string]: any } = { creativeId: "" };
    let contentArray: ContentListEntry[] = [];
    let files;
    let client: S3Client;
    let uploading = false;
    let message = "";

    async function getContents() {
        const recursiveFetch = async (page: number) => {
            contentArray = [];
            await ApiClient.getInstance($user)
                .contentClient.listContents({ size: 100, page })
                .then((contents) => {
                    contentArray = [...contentArray, ...contents.entries];
                    if (!contents.hasNext) return;
                    recursiveFetch(contents.page + 1);
                });
        };
        await recursiveFetch(0);
        loading = false;
    }

    $: if (contentArray.length > 0) {
        rows = contentArray.map((contentItem) => {
            return {
                creativeId: contentItem.id,
                releaseStatus: contentItem.releaseStatus,
                url: contentItem.url,
                name: contentItem.name,
            };
        });
    }

    let checkedRows = [];

    // define column configs
    const columns = [
        {
            key: "checkbox",
            title: "",
            value: CheckboxElement,
            renderComponent: {
                component: CheckboxElement,
                props: {
                    idKey: "creativeId",
                    storeKey: "selectedCampaigns",
                },
            },
        },
        {
            key: "name",
            title: "ID",
            value: (v) => v?.name,
            sortable: true,
            renderComponent: BaseRowElement,
        },
        {
            key: "url",
            title: "Vorschau",
            value: (v) => v?.url,
            renderComponent: ContentPreviewElement,
        },
        {
            key: "releaseStatus",
            title: "Status",
            value: (v) => v?.releaseStatus,
            sortable: true,
            renderComponent: BaseRowElement,
        },
        {
            title: "Freigabe",
            value: (v) => v?.creativeId,
            renderComponent: {
                component: ApprovalActionsRowElement,
                props: {
                    callback: getContents,
                },
            },
        },
    ];

    const userInteraction = async () => {
        await $user.updateToken().then(async () => {});
    };

    const createNewContent = async () => {
        if (!newContentUrl || !newContentName) {
            alert("Beide Felder müssen ausgefüllt sein.");
            return;
        }
        newContentModalOpen = false;
        await ApiClient.getInstance($user)
            .contentClient.createContent({
                contentRequest: {
                    url: newContentUrl,
                    active: true,
                    name: newContentName,
                    // tags: [{ id: "name", values: [newContentName] }],
                },
            })
            .then(console.log);
        getContents();
    };

    const uploadFile = async () => {
        uploading = true;
        if (!files.length) {
            return alert("Please choose a file to upload first.");
        }
        var file = files[0];
        var fileName = file.name;

        var photoKey = fileName;
        const uploadParams = {
            Bucket: "dev-bucket-whizad",
            Key: photoKey,
            Body: file,
        };

        // Use S3 ManagedUpload class as it supports multipart uploads
        await client
            .send(new PutObjectCommand(uploadParams))
            .then((res) => {
                uploading = false;
                message = "Datei erfolgreich gespeichert";
                newContentUrl = `https://dev-bucket-whizad.s3.eu-central-1.amazonaws.com/${fileName}`;
            })
            .catch((err) => {
                uploading = false;
                message = err;
            });
        // var promise = upload.promise();

        // promise.then(
        //     function (data) {
        //         alert("Successfully uploaded photo.");
        //         viewAlbum(albumName);
        //     },
        //     function (err) {
        //         return alert(
        //             "There was an error uploading your photo: ",
        //             err.message
        //         );
        //     }
        // );
    };

    onMount(async () => {
        userInteraction();
        await getContents();

        // let data = {
        //     authUrl: "https://10.6.66.3:5000/v3",
        //     userName: "dd.whizad",
        //     apiKey: "GsP9&Drumf9vQX",
        //     tenant: "whizad",
        //     domain: "uqunu_c1",
        // };

        // const authenticator = fetch(data.authUrl, {
        //     method: "POST",
        //     headers: new Headers({
        //         "x-auth-user": data.userName,
        //         "x-auth-key": data.apiKey,
        //     }),
        // }).then(console.log);

        // const file = fetch(
        //     "https://10.6.66.100/swift/v1/AUTH_1494a3ff1ff34446854cfcf81af21fbb/public/",
        //     {
        //         method: "GET",
        //         headers: new Headers({
        //             "x-auth-user": data.userName,
        //             "x-auth-key": data.apiKey,
        //         }),
        //     }
        // ).then(console.log);
        // let client = new SwiftClient(authenticator);
        // let client = await new SwiftClient(data).authenticate();
        client = new S3Client({
            region: "eu-central-1",

            credentials: fromCognitoIdentityPool({
                clientConfig: { region: "eu-central-1" }, // Configure the underlying CognitoIdentityClient.
                identityPoolId:
                    "eu-central-1:2aaaf671-27fb-43df-9f0c-7584249d5f23",
            }),
        });

        // client
        //     .send(
        //         new ListObjectsCommand({
        //             Bucket: "dev-bucket-whizad",
        //         })
        //     )
        //     .then(console.log);

        // // client.middlewareStack.remove("validate");
        // // client.middlewareStack.remove("sign");\

        // const data = {
        //     accessKeyId: AccessKeyId,
        //     secretAccessKey: SecretKey,
        //     sessionToken: SessionToken,
        // };
        // client.send(new AWS.ListBucketsCommand({})).then(console.log);

        // sc(
        //     new SwiftAuthenticator(
        //         "https://10.6.66.100/swift/v1/AUTH_1494a3ff1ff34446854cfcf81af21fbb",
        //         "dd.whizad",
        //         "XRF-cgz8zkj-eyr@kzk"
        //     )
        // );
        // let container = client.container("test");
        // container.get("test-file", console).then(() => {
        //     console.log("Done!");
        // });
    });
</script>

<div class="columns is-multiline">
    <div class="column is-12">
        <div class="card sticky">
            <div class="card-content">
                <div class="content">
                    <div class="columns is-vcentered is-multiline">
                        {#if loading}
                            <div class="column is-12">
                                <span
                                    class="icon-text has-text-info"
                                    style="margin: auto;"
                                >
                                    <span class="icon is-large">
                                        <i
                                            class="fas fa-spinner fa-pulse"
                                            style="height: 1.5rem; width: 1.5rem;"
                                        />
                                    </span>
                                    <span
                                        style="margin: auto; padding-left: 10px; font-size: 1.25rem;"
                                        >Loading ...</span
                                    >
                                </span>
                            </div>
                        {:else}
                            <div class="column is-3 ">
                                <p class="is-5 greenish">Content</p>
                            </div>
                            <div class="column is-3 ">
                                <p class="greenish is-5">Status</p>
                            </div>
                            <div class="column is-3">
                                <p class="greenish is-5">Video</p>
                            </div>
                            <div class="column is-3">
                                <p class="greenish is-5">Freigabe</p>
                            </div>

                            {#each contentArray as content}
                                <ContentCard
                                    contentEntry={content}
                                    refreshCall={getContents}
                                />
                            {/each}
                            <!-- {#if $usersStore.users && $usersStore.users.entries}
                                <Pagination />
                            {/if} -->
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .table-wrapper {
        max-height: calc(100vh - 156px);
        overflow: auto;
    }

    tr th:hover {
        cursor: pointer;
    }

    .sticky {
        position: sticky;
        top: 0rem;
    }

    .column {
        text-align: center;
    }

    .card {
        border-radius: 100px;
        padding: 1rem;
        padding-bottom: 0;
    }

    .greenish {
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        margin: 0 11px;
        padding: 13px;
    }

    .greenish-plus {
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        width: 50px;
        margin: auto;
        padding: 13px;
        font-size: 2rem;
        font-weight: 600;
        line-height: 25px;
    }

    .greenish-plus:hover {
        cursor: pointer;
    }
</style>
